import React, { FC, ReactNode } from "react";
import { Checkbox, IconButton, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Reminder } from "@models/reminder";
import TableCell from "@mui/material/TableCell";
import StyledLink from "@components/StyledLink/StyledLink";
import TableRow from "@mui/material/TableRow";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import InsertPhotoOutlinedIcon from "@mui/icons-material/InsertPhotoOutlined";
import MedicationOutlinedIcon from "@mui/icons-material/MedicationOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import StyledChip from "@components/StyledChip";
import { CronUtil } from "@utils/cron.util";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import NotificationsOffOutlinedIcon from "@mui/icons-material/NotificationsOffOutlined";
import { ActivityType } from "@models/activity-type";

export interface ReminderRowProps {
  selected: boolean;
  reminder: Reminder;
  onSelect: () => void;
  onEdit: () => void;
  onEnabledChange: () => void;
}

const icons: Record<ActivityType, ReactNode> = {
  [ActivityType.Conversation]: <SmsOutlinedIcon fontSize="small" />,
  [ActivityType.GallerySession]: <InsertPhotoOutlinedIcon fontSize="small" />,
  [ActivityType.Medication]: <MedicationOutlinedIcon fontSize="small" />,
  [ActivityType.Other]: <CalendarMonthOutlinedIcon fontSize="small" />,
};

const ReminderRow: FC<ReminderRowProps> = ({
  selected,
  reminder,
  onSelect,
  onEdit,
  onEnabledChange,
}) => {
  const { t } = useTranslation();
  return (
    <TableRow>
      <TableCell scope="row">
        <Checkbox checked={selected} onClick={onSelect} />
      </TableCell>
      <TableCell>
        <StyledLink to={""} onClick={onEdit}>
          {reminder.title}
        </StyledLink>
      </TableCell>
      <TableCell>
        <Stack flexDirection="row" gap="8px" alignItems="center">
          {icons[reminder.activityType]}
          {t(`schedule.types.${reminder.activityType}`)}
        </Stack>
      </TableCell>
      <TableCell>
        <StyledChip
          label={CronUtil.toHumanReadable(reminder.schedule)}
          variant="filled"
          color="primary"
        />
      </TableCell>
      <TableCell>
        <IconButton onClick={onEnabledChange}>
          {reminder.isActive ? (
            <NotificationsOutlinedIcon />
          ) : (
            <NotificationsOffOutlinedIcon />
          )}
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default ReminderRow;
